// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */:host{display:flex;flex:1;flex-direction:column}gh-page-content{display:flex;flex-direction:column}.title-with-buttons span{padding-right:30px}.button-panel .mat-raised-button+.mat-raised-button,.button-panel .mat-mdc-raised-button+.mat-mdc-raised-button{margin-left:15px}`, "",{"version":3,"sources":["webpack://./packages/builder-contacts/contact-details/components/contact-details-shared-communication-list-tab/contact-details-shared-communication-list-tab.scss"],"names":[],"mappings":"AAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAQA,MACE,YAAA,CACA,MAAA,CACA,qBAAA,CAGF,gBACE,YAAA,CACA,qBAAA,CAIA,yBACE,kBAAA,CAIJ,gHAEE,gBAAA","sourcesContent":["/*!\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */\n\n@use \"theme/styles/settings\" as *;\n@use \"theme/styles/tools\" as *;\n\n:host {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n}\n\ngh-page-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.title-with-buttons {\n  span {\n    padding-right: 30px;\n  }\n}\n\n.button-panel .mat-raised-button + .mat-raised-button,\n.button-panel .mat-mdc-raised-button + .mat-mdc-raised-button {\n  margin-left: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
